import React from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import RidingList from '../components/PointOfinterestType/RidingList'
import RoadCyclingPoints from '../components/PointOfinterestType/RoadCyclingPoints'
import RoadCyclingClassification from '../components/PointOfinterestType/RoadCyclingClassification'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

import { usePois } from '../contexts/PoisContext'
import { setFlashMessage } from '../contexts/WebsiteContext'

const PoiTypeRoadCycling = () => {
  const poiType = 'ROAD_CYCLING'
  const pageName = `POI_TYPE_${poiType}`
  const { t, i18n } = useTranslation()
  const { pois } = usePois()

  const filteredPois = pois.filter((poi) => poi.poiType.name === poiType)

  if (!pois.length) {
    setFlashMessage(t('ERROR_MESSAGE'), 'error')
    console.log('Pas de résultat pour le poi type ', poiType)
  }

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t(`${pageName}_PAGE_TITLE`)}
        description={t(`${pageName}_PAGE_DESCRIPTION`)}
      />

      <div className="container section py-4">
        <p className="lead">{t(`${pageName}_PAGE_DETAILS`)}</p>

        {filteredPois.length > 0 && <RidingList pois={filteredPois} />}

        <hr />
        <RoadCyclingPoints />

        <hr />
        <RoadCyclingClassification />

        <BottomImage name={pageName} lang={i18n.language} />
      </div>

      <Footer />
    </div>
  )
}

export default PoiTypeRoadCycling
